const announcementsES = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} anuncios no leídos",
            "empty": "No hay anuncios",
            "newBadge": "Nuevo",
            "dismissAll": "Descartar todo",
        },
        "modal": {
            "defaultTitle": "Anuncio",
        },
        "table": {
            "title": "Anuncios",
            "column": {
                "title": "Título",
                "datePosted": "Fecha de publicación",
                "dismissed": "Descartado",
                "status": "Estado",
                "action": "Acción",
            },
            "status": {
                "read": "Leído",
                "unread": "No leído",
            },
            "csv": {
                "statusRead": "Leído",
                "statusUnread": "No leído",
                "dismissedYes": "Descartado",
                "dismissedNo": "No descartado",
            },
            "action": {
                "view": "Ver",
            },
            "button": {
                "exportCsv": "Exportar CSV",
            },
        },
    },
};

export default announcementsES;
